import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';

export const templatePackages = document.createElement('template');

templatePackages.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>
    <div class='loading-container'>
        <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>
    <gz-download-security-container></gz-download-security-container>
    <gz-download-k8s-agent></gz-download-k8s-agent>
    <gz-packages-grid></gz-packages-grid>
  </div>
`;
